function setHowToAdjustSwiper () {
  const element = document.getElementById('js-howToAdjust-swiper');
  if ( element ) {
    const swiper = new Swiper(element, {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}
setHowToAdjustSwiper();

function setProductCardSwiper () {
  const elements = document.querySelectorAll('.js-product-card-swiper');
  elements.forEach(function(element, index){
    const swiper = new Swiper(element, {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination'
      }
    })
  })
}
setProductCardSwiper();

function setDrawer() {
  const button = document.getElementById('js-header-toggleButton');
  const drawer = document.getElementById('js-drawer');
  if ( !button || !drawer ) return;
  button.addEventListener('click', function(){
    drawer.classList.toggle('_open');
    button.classList.toggle('_open');
  })
  const drawerLinks = drawer.querySelectorAll('a');
  drawerLinks.forEach(function(link, index){
    link.addEventListener('click', function(){
      button.classList.toggle('_open', false);
      drawer.classList.toggle('_open', false);
    });
  })
}
setDrawer();

const header = document.getElementById('js-header');
function updateHeaderOnScroll() {
  window.addEventListener('scroll', function(){
    if ( header ) {
      if ( window.scrollY < 50) {
        header.classList.add('_isTop');
      } else {
        header.classList.remove('_isTop');
      }
    }
  })
}
document.addEventListener('DOMContentLoaded', function(){
  const firstview = document.querySelector('.firstview');
  if (firstview){
    header.classList.add('_isTop');
    updateHeaderOnScroll();
  }
});

function voicesSlider(){
  const targetCollection = document.querySelectorAll('.voices-swiper');
  targetCollection.forEach(function(target, index){
    if ( !target ) return;
    const swiper = new Swiper (target,{
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        990:{
          slidesPerView: 3,
        }
      }
    })
  })
}
voicesSlider();

function pageTop (){
  const button = document.getElementById('pageTop');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      button.classList.add('is-show');
    } else {
      button.classList.remove('is-show');
    }
  });

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

pageTop();